import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import React, {Fragment} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import EditPostButton from './EditPostButton';
import EditCommentButton from './EditCommentButton';
import ViewCommunityItemBtn from './ViewCommunityItemButton';
import PreviewCommunityButton from './PreviewCommunityButton';
import { abbrNum } from './../helpers';
import { faTrash, faReply, faFlag, faComment, faThumbsUp } from '@fortawesome/free-solid-svg-icons'
import { ConfirmJsMessage } from '../helpers.js'
import Moment from "react-moment"
import Grid from '@material-ui/core/Grid';
import Avatar from 'react-avatar';
import ReactImageFallback from "react-image-fallback";

class CommunityList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tab: props.defaultTab ? props.defaultTab : 0
		};
	}

	handleChange = field => event => {
		this.setState({
			...this.state,
			formData: {
				...this.state.formData,
				[field]: event.target.value,
			},
		});
	};

	deleteItem = (id) => {
		if (ConfirmJsMessage(`All informations related with this ${this.props.itemType} will be lost. Are you sure you want to delete the ${this.props.itemType}? `)) {
			this.props.deleteItem(id, this.props.itemType).then(() => {
				window.location.reload();
			});
		}
	}

	movePostPage = (id) => {
		this.props.history.push(`/community/topic/${id}`);
	}

	toTitleCase = (phrase) => {
		let capitalize;
		if(phrase) {
			capitalize = phrase
			.toLowerCase()
			.split(' ')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
		}
		return capitalize;
	};

	getName = (user) => {
		let name;
		if (user.type.includes('corporate') || user.type.includes('brand')) {
			name = user.brandName;
		}
		if (user.type.includes('basic') || user.type.includes('trainer')) {
			let names = []
			if (user.firstName) {
				names.push(user.firstName);
			}
			if (user.lastName) {
				names.push(user.lastName);
			}
			// if (names.length > 0) {
				names = names.join(" ");
			// }
			name =  names;
		}
		return this.toTitleCase(name) || 'User';
	}

	getAvtar = (user) => {
		let imageUrl;
		if (user.type.includes('basic')) {
			imageUrl = user.consumerImg;
		}
		if (user.type.includes('trainer')) {
			imageUrl = user.trainerImg;
		}
		if (user.type.includes('corporate') || user.type.includes('brand')) {
			imageUrl = user.brandImg;
		}
		if (imageUrl) {
			return (<Avatar src={imageUrl} size="32" round={true} />)	
		} else {
			let name = []
			if (user.firstName) {
				name.push(user.firstName);
			}
			if (user.lastName) {
				name.push(user.lastName);
			}
			if (name.length > 0) {
				name = name.join(" ");
				return (<Avatar name={name} size="32" round={true} />)	
			} else {
				return (<Avatar src="/assets/img/no-image.png" size="32" round={true} />)	
			}
		}									
	}

	renderButtons(item) {
		const { isMobile } = this.props;
		switch (this.props.itemType) {
			case 'comment':
				return (
					<div>
						<span
							className="link"
							onClick={() => this.deleteItem(item._id)}
							style={{ float: 'right' }}>
							<FontAwesomeIcon size={isMobile && "2x"} icon={faTrash} title={'Delete'}
								style={{ marginRight: 5, color: COLORS.orange }} />
						</span>
						{ (this.props.user._id === item.creatorId) &&
							<EditCommentButton isMobile = {isMobile } item={item} topic={this.props.topic} />
						}
						<PreviewCommunityButton isMobile = {isMobile} community={item} />
					</div>
				);
			default:
				return null;
		}
	}
	render() {
		const { search, categoryId, equipmentId, partId, tab } = this.state;
		const {
			items,
			user,
			selectedItems,
			maxListHeight,
			itemType,
			isPhoto,
			isMobile,
		} = this.props;

		let styleWidth = '90%';
		if (itemType === 'post_like' || itemType === 'post_flag' || isMobile) {
			styleWidth = '100%';
		}

		
		return (
			<div>
				<div
					style={{
						backgroundColor: COLORS.greyFour,
						paddingTop: 0,
						paddingBottom: 0,
						display: 'flex',
						alignItems: 'center',
						flexDirection: 'column',
					}}
				>
					<div style={{ width: '100%' }}>
						<div
							style={{
								maxHeight: maxListHeight ? maxListHeight : 'auto',
								overflow: 'auto',
							}}
						>
							{items.map((item, index) => {
								let classListItem = 'listItem';
								if (item.isTranscoding) {
									classListItem = 'listItem listItemDisable'
								}
								return (
									<Fragment>
										<div className={classListItem} key={index}>
											<div
												style={{
													width: styleWidth,
													display: 'flex',
													alignItems: 'center',
												}}
											>
											{ itemType === 'topic' &&
												<div className="nowrap">
													<b>{item.title} { item.isTranscoding &&
																			<em style={{
																			'fontSize': '14px',
																			'color': 'red'
																			}}> (Processing)</em>
																		} </b>
													<br></br>
													{item.description}
												</div>
											}
											{ (itemType === 'post' && isPhoto) && 
												<div className="nowrap">
													<Grid container style={{ 
														padding: 0,
														display: 'flex',
														'justifyContent': 'center',
														'alignItems': 'center'
													}}>
														<Grid item xs={1} style={{ maxWidth: 40 }}>
															{ item.user && item.user.length > 0 &&
																this.getAvtar(item.user[0])
															}
														</Grid>
														<Grid item xs={6}>	
															{ item.user && item.user.length > 0 &&
																<Fragment>
																	<span style={{
																		'fontSize': '14px',
																		'display': 'block',
																		'height': '15px',
																		'fontWeight': 'bold'
																	}}>
																		{this.getName(item.user[0])}
																		</span>
																</Fragment>
															} 
															<Moment className="text-muted"  style={{
																		'fontSize': '10px',
																		'display': 'block',
																		'height': '12px',
																		'marginTop': '4px'
																	}}  format="D MMM YYYY">{item.createdAt}</Moment>
															{/* {itemType === 'post' ? 
																<span style={{
																	'fontWeight': 'bold',
																	'fontSize': '13px',
																}}>{`${abbrNum(item.totalViews, 2)} Views`} </span> : 
																'' } */}
														</Grid>
														<Grid item xs={5}>
														<ReactImageFallback 
															src={item.url} 
															fallbackImage={'/assets/img/no-image-icon.png'}
															className="photo_responsive" />
														</Grid>
														
													</Grid>
												</div>
											}
											{ (itemType === 'post' || itemType === 'comment') && !isPhoto && 
												<div className={isMobile ? 'mobile_post_wrap': 'post_wrap'}>
													<Grid container style={{ 
														padding: 0,
													}}>
														<Grid item xs={1} style={{ maxWidth: 40 }}>
															{ item.user && item.user.length > 0 &&
																this.getAvtar(item.user[0])
															}
														</Grid>
														<Grid item xs={isMobile ? 10 : 6}>	
																
														{ item.user && item.user.length > 0 &&
																<Fragment>
																	<span style={{
																		'fontSize': '14px',
																		'display': 'block',
																		'height': '15px',
																		'fontWeight': 'bold',
																		'marginLeft': isMobile && '10px'
																	}}>
																		{this.getName(item.user[0])}
																		{ item.isTranscoding &&
																			<em style={{
																			'fontSize': '14px',
																			'color': 'red'
																			}}> (Processing)</em>
																		}
																		</span>
																		
															
																</Fragment>
															}
															<span style={{
																whiteSpace: "nowrap",
																textOverflow: "ellipsis",
																width: isMobile ? "100%" : "300px",
																display: "block",
																fontSize: '13px',
																overflow: "hidden",
																marginLeft: isMobile && '10px',
																marginTop: isMobile && '5px'
															}}> {item.description} 
														</span>
														{ isMobile && 
															<span style={{
																'fontSize': '14px',
																'display': 'block',
																'height': '15px',
																'fontWeight': 'bold',
																'marginLeft': isMobile && '10px',
																
															}}>
																<Moment className="text-muted" format="D MMM YYYY">{item.createdAt}</Moment>
															</span>
														}
														{ isMobile &&
														  <div style={{ 
															width: '100%',
															float: 'right',
															marginTop: '10px' 
														}}>{this.renderButtons(item)}</div>
														}
														</Grid>
														{ !isMobile &&
															<Grid item xs={5} style={{ textAlign:'left', marginTop:'8px', marginLeft: itemType === 'post' ? '20px' : '0px'}}>
																<Moment className="text-muted" format="D MMM YYYY">{item.createdAt}</Moment>
															</Grid>
														}
													</Grid>
												</div>
											}
											{ (itemType === 'post_like') &&
												<div className="nowrap">
													{ item.user && item.user.length > 0 &&
															<Grid container style={{ padding: 0 }}>
																<Grid item xs={1} style={{ maxWidth: 40 }}>
																	{ item.user && item.user.length > 0 &&
																		this.getAvtar(item.user[0])
																	}
																</Grid>
																<Grid item xs={5}>
																	{this.getName(item.user[0])}
																</Grid>
																<Grid item xs={6} style={{ textAlign:'right' }}>
																	<Moment className="text-muted" format="D MMM YYYY">{item.createdAt}</Moment>
																</Grid>
															</Grid>
													}
												</div>
											}
											{ (itemType === 'post_flag') &&
												<div className="nowrap">
													{ item.user && item.user.length > 0 &&
															<Grid container style={{ padding: 0 }}>
																<Grid item xs={1} style={{ maxWidth: 40 }}>
																	{ item.user && item.user.length > 0 &&
																		this.getAvtar(item.user[0])
																	}
																</Grid>
																<Grid item xs={5}>
																	{item.user[0].firstName } {item.user[0].lastName}
																</Grid>
																<Grid item xs={1}>
																	<span style={{
																		'fontSize': '12px',
																		'color': 'red'
																	}}>
																	{item.isSpam ? 'Spam' : 'Inappropriate'}
																	</span>
																</Grid>
																<Grid item xs={5} style={{ textAlign:'right' }}>
																	<Moment className="text-muted" format="D MMM YYYY">{item.createdAt}</Moment>
																</Grid>
															</Grid>
													}
												</div>
											}
											</div>
											{ !isMobile &&
											<div style={{ width: '15%' }}>{this.renderButtons(item)}</div>
											}
										</div>
										
									</Fragment>
								)}
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default CommunityList;



// WEBPACK FOOTER //
// ./src/components/CommunityList.js